export const ruleTableOptions = {
    columns: [
        { label: '策略编号', prop: 'strategyCode'},
        { label: '策略名称', prop: 'strategyName'},
        { label: '策略分类', prop: 'scene'},
        { label: '策略描述', prop: 'strategyDesc'},
        { label: '策略逻辑', prop: 'strategyExpression'},
        // { label: '策略规则集', prop: 'ruleDesc'},
        // { label: '策略执行动作', prop: 'ruleDesc'},
        { label: '操作', prop: 'operators'},
        { label: '是否启用', prop: 'status'},
    ],
}

export const getDataType = (code) => {
    switch (code) {
        case 20:
        case 30:
        case 40:
        case 50:
            return 'number';
        case 70:
            return 'boolean';
        default:
            return 'string';
    }
}

export const getLogicOperatorEnum = (operator) => {
    if(operator == 'and') {
        return 100;
    } else {
        return 110;
    }
}


export const employeeData = [{
    'EmployeeID': 1,
    'FirstName': 'Nancy',
    'Title': 'Sales Representative',
    'TitleOfCourtesy': 'Ms.',
    'HireDate': '22/07/2001',
    'City': 'Seattle',
    'Country': 'USA'
  }];

  
  export const RuleDatas = {
    "operatorType": 110,
    "leftChild": {
        "operatorType": 100,
        "leftChild": {
            "operatorType": 140,
            "leftChild": {
                "operatorType": 0,
                "leftChild": null,
                "rightChild": null,
                "value": {
                    "isConstant": false,
                    "code": "Feature12345677656",
                    "constantValue": null
                },
                "expression": null,
                "hitCondition": "10"
            },
            "rightChild": {
                "operatorType": 0,
                "leftChild": null,
                "rightChild": null,
                "value": {
                    "isConstant": false,
                    "code": "Feature12345677657",
                    "constantValue": null
                },
                "expression": null,
                "hitCondition": "10"
            },
            "hitCondition": "20"
        },
        "rightChild": {
            "operatorType": 140,
            "leftChild": {
                "operatorType": 0,
                "leftChild": null,
                "rightChild": null,
                "value": {
                    "isConstant": false,
                    "code": "Feature12345677656",
                    "constantValue": null
                },
                "expression": null,
                "hitCondition": "10"
            },
            "rightChild": {
                "operatorType": 0,
                "leftChild": null,
                "rightChild": null,
                "value": {
                    "isConstant": false,
                    "code": "Feature12345677657",
                    "constantValue": null
                },
                "expression": null,
                "hitCondition": "10"
            }
        },
        "value": null,
        "expression": null,
        "hitCondition": "10"
    },
    "rightChild": {
        "operatorType": 140,
            "leftChild": {
                "operatorType": 0,
                "leftChild": null,
                "rightChild": null,
                "value": {
                    "isConstant": false,
                    "code": "Feature12345677656",
                    "constantValue": null
                },
                "expression": null,
                "hitCondition": "10"
            },
            "rightChild": {
                "operatorType": 0,
                "leftChild": null,
                "rightChild": null,
                "value": {
                    "isConstant": false,
                    "code": "Feature12345677657",
                    "constantValue": null
                },
                "expression": null,
                "hitCondition": "10"
            }
    },
    "value": null,
    "expression": null,
    "hitCondition": "10"
}